import { render, staticRenderFns } from "./consent-sign.vue?vue&type=template&id=bbefac9c&"
import script from "./consent-sign.vue?vue&type=script&lang=js&"
export * from "./consent-sign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "consent-sign.vue"
export default component.exports